import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  isLoading: true,
  donationsList: [],
};

const donationsSlice = createSlice({
  name: "Donations",
  initialState,
  reducers: {
    setDonationsList(state, actions) {
      state.donationsList = actions.payload;
      state.isLoading = false;
    },

  },
});


export const { setDonationsList }= donationsSlice.actions;

const donationsReducer = donationsSlice.reducer;

export default donationsReducer;